export enum ERRORS {
    TOKEN_EXPIRED = 'Token expired',
    BAD_TOKEN = 'Bad token',
  
    USER_BLOCKED = 'هذا الحساب موقوف',
    USER_NOT_FOUND = 'مستخدم غير موجود',
    USER_REQUIRED_FIELDS = 'إملأ جميع الحقول المطلوبة',
    DUPLICATE_EMAIL = 'البريد الإلكتروني موجود بالفعل',
    DUPLICATE_USERNAME = 'اسم المستخدم موجود بالفعل',
    BAD_CREDENTIAL = 'مستخدم غير موجود أو كلمة مرور خاطئة',

    SHIPP_ID_MISSING = 'رقم الطرد مطلوب',
    SHIPP_NOT_FOUND = 'الطرد غير موجود',
  DUPLICATE_URL = 'A post with this URL already exists',
  
    COMMENT_MISSING = 'Comment is missing',
    COMMENT_ID_MISSING = 'Comment ID is missing',
  
    DUPLICATE_LIKE = 'Duplicate like',

    MISSING_FIELDS =  'بعض الحقول ناقصة',
BAD_INPUTS = 'مدخلات غير صالحة',
    SERVER_ERROR = 'خطا بالخادم، رجاء المحاولة مجدداً',
 INVALID_PASSWORD = 'كلمة المرور لابد أن تحتوي على حروف كبيرة وصغيرة وأرقام ولا تقل عن ستة أحرف'
  }